import * as React from "react";

import { cn } from "../../lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-10 w-full rounded-md",
          "border border-[var(--color-ratia-line)] bg-card",
          "px-3 py-2 text-sm text-[var(--color-ratia-ink)]",
          "placeholder:text-[var(--color-ratia-ink-3)]",
          "ring-offset-background transition-colors duration-150 ease-out",
          "file:border-0 file:bg-transparent file:text-sm file:font-medium",
          "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--color-ratia-blue-500)] focus-visible:border-[var(--color-ratia-blue-500)]",
          "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-[var(--color-ratia-paper-2)]",
          "aria-[invalid=true]:border-[var(--color-ratia-red)] aria-[invalid=true]:focus-visible:ring-red-300",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
